module.exports = __webpack_public_path__ + "static/media/service-box6-icon05.811458d0.png";